"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initMROAuth = initMROAuth;
var _mrOAuth = require("../constants/mrOAuth");
var _events = require("../types/events");
var _mrOAuth2 = require("../../browser/types/mrOAuth");
var _tracking = require("../utils/tracking");
var _mrOAuth3 = require("../actions/mrOAuth");
function initMROAuth(_ref) {
  let {
    authClient,
    eventEmitter,
    store
  } = _ref;
  authClient.init({
    clientId: _mrOAuth.MR_OAUTH_CLIENT_ID,
    mode: _mrOAuth2.EAuthMode.OneTap,
    ttlCloseState: 0,
    onunavailable: info => {
      eventEmitter.emit(_events.EEventType.MROAuthUnavailable, info);
    },
    onshow: info => {
      (0, _tracking.trackMROAuthShown)();
      eventEmitter.emit(_events.EEventType.MROAuthShown, info);
    },
    onclose: info => {
      (0, _tracking.trackMROAuthClosed)();
      eventEmitter.emit(_events.EEventType.MROAuthClosed, info);
    },
    onlogin: state => {
      if (state.status === _mrOAuth2.EAuthStatus.Connected) {
        store.dispatch((0, _mrOAuth3.authenticate)({
          email: state.user.email,
          accessToken: state.access_token
        }));
      } else {
        throw new Error('Unexpected AuthStatus on login');
      }
    }
  });
}